import React from 'react'
import MaterialSymbol from '../material-symbol'

const DarkMode = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="dark_mode" {...props} />
))

DarkMode.displayName = 'DarkMode'

export default DarkMode
